import template from "./pre-select.html";
import {
	EVENT_VALUE_CHANGED,
	EVENT_CLEAR_ROW
} from "constants.js";

// selection
export class Controller {
	lookups = [];
	uiHelpers = null;

	constructor($scope, eventBus, uiHelpers, featureHelper, $timeout, $logger) {
		this._scope = $scope;
		this.uiHelpers = uiHelpers;
		this.featureHelper = featureHelper;
		this.filteredData = {};
		this.$timeout = $timeout;
		this.$logger = $logger;
	}

	$onInit() {
		this._eventBus = this.reportScope.events;
		this.setOptionIdType();
		this.registerEvents();
		this.preSelectValue();
	}

	setOptionIdType() {
		switch(this.field.Type.Code) {
			case "ENTITYCONTACT":
			case "ENTITY":
				this.optionIdType = "EntityId";
				break;

			default: //AREA, PORT, REEF, SPECIES,
				this.optionIdType = "DataId";
				break;
		}
	}

	registerEvents() {
		this._unregister = this.reportFormCtrl.registerFieldController(this);
	}

	$onDestroy() {
		this._unregister && this._unregister();
	}

	preSelectValue() {
		const value = this.field.dataDictionary[this.repeatId];

		if(!value) {
			return;
		}
		this.preselectedValue = value;
		this.value = value.Id;

		if(this.value) {
			this.handleValueChanged();
		}
	}

	handleValueChanged() {
		this.selection = this.field.dataDictionary[this.repeatId];

		if(!this.selection && !!this.value) {
			this.selection = { Id: this.value };
		}

		if(this.lastSelectionId !== this.selection?.Id) {
			this._eventBus.trigger(EVENT_VALUE_CHANGED(this.field.Id, this.repeatId), {
				field: this.field,
				value: this.selection
			});
		}

		this.lastSelectionId = this.selection?.Id;
	}

	getCurrentValue(isApiCall = false) {
		let result = this.buildResult();

		if(!isApiCall) {
			if(!result) {
				result = { FieldId: this.field.Id };
				result.hasResultForRuleRun = false;
			}

			result.isDirty = false;

			if(this.selection) {
				result.Classifications = this.selection.Classifications;
				result._code = this.selection.Code;
			}
		}

		return result ? [result] : [];
	}

	buildResult() {
		let result;
		if(this.selection && this.selection.Id) {
			result = {
				FieldId: this.field.Id
			};
			result[this.optionIdType] = this.selection.Id;

			if(this.repeatId) {
				result.repeatId = this.repeatId;
			}
		}
		return result;
	}

	setPristine() { }

	clearRow() {
		this._eventBus.trigger(EVENT_CLEAR_ROW(this.repeatId));
	}
}

export default angular
	.module("vesl.components.report-form.pre-select", [])
	.component("preSelect", {
		template,
		controller: Controller,
		bindings: {
			field: "<",
			values: "<",
			repeatId: "<"
		},
		require: {
			reportFormCtrl: "^reportForm",
			reportScope: "^^reportScope"
		}
	}).name;
